const BlockchainSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
        <g clipPath="url(#clip0_307_12179)">
            <path d="M37.2245 63.3469H11.1021C5.33124 63.3469 0.653076 58.6688 0.653076 52.8979V26.7755C0.653076 21.0047 5.33124 16.3265 11.1021 16.3265H37.2245C42.9953 16.3265 47.6735 21.0047 47.6735 26.7755V52.8979C47.6735 58.6688 42.9953 63.3469 37.2245 63.3469Z" stroke="#D100C9" strokeWidth="2" />
            <path d="M52.898 47.6735H26.7755C21.0047 47.6735 16.3265 42.9953 16.3265 37.2245V11.102C16.3265 5.33122 21.0047 0.653053 26.7755 0.653053H52.898C58.6688 0.653053 63.3469 5.33122 63.3469 11.102V37.2245C63.3469 42.9953 58.6688 47.6735 52.898 47.6735Z" stroke="#D100C9" strokeWidth="2" />
            <path d="M45.0612 55.5103H18.9387C13.1679 55.5103 8.48975 50.8321 8.48975 45.0613V18.9388C8.48975 13.168 13.1679 8.48985 18.9387 8.48985H45.0612C50.832 8.48985 55.5102 13.168 55.5102 18.9388V45.0613C55.5102 50.8321 50.832 55.5103 45.0612 55.5103Z" stroke="#D100C9" strokeWidth="2" />
        </g>
        <defs>
            <clipPath id="clip0_307_12179">
                <rect width="64" height="64" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

export default BlockchainSvg; 